import type { GetLockboxResponse, JsonObject } from '@/app-package';
import axios from 'axios';

interface Query {
  page: number;
  userName?: string;
  brands?: string[];
  serialNumber?: string;
  owners?: string[];
  assignees: string[];
  sortField?: string;
  sortOrder?: number | 'asc' | 'desc';
  size: number;
}

export type Lockbox = JsonObject<GetLockboxResponse>['lockboxes'][number];

// TODO: Update getLockboxDTO
const getLockbox = async (queryOptions?: Query) => {
  const { data } = await axios.get<JsonObject<GetLockboxResponse>>(`/lockbox`, {
    params: queryOptions,
  });

  return data;
};

export default getLockbox;
